import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'sanitizeHtml',
    standalone: false
})
export class SanitizeHtmlPipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}
  transform(v: string): SafeHtml {
    const url = this._sanitizer.sanitize(SecurityContext.URL, v.toString());
    return this._sanitizer.bypassSecurityTrustHtml(url);
  }
}
